export function HuiBox() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: () => {
        },
        bindToController: {
            sizing: '@',
            variant : '@',
        },
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui hui-box" ng-class="[$huiCtrl.sizing || 'md',
                                                   { 'hui-box-card': $huiCtrl.variant === 'card' }]" 
                                                   ng-transclude></div>
            `;
        }
    }
}

export function HuiBoxHeader() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: () => {
        },
        bindToController: {
            as: '@'
        },
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            
            const tagName = $attrs.as || 'h3';
            
            return `
                <${tagName} class="hui hui-box-header" ng-transclude></${tagName}>
            `;
        }
    }
}

export function HuiBoxBody() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: () => {
        },
        bindToController: {},
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui hui-box-body" ng-transclude></div>
            `;
        }
    }
}

export function HuiBoxFooter() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        controller: () => {
        },
        bindToController: {},
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui hui-box-footer" ng-transclude></div>
            `;
        }
    }
}